import { render, staticRenderFns } from "./TabLeadInformation.vue?vue&type=template&id=67cd5504"
import script from "./TabLeadInformation.vue?vue&type=script&lang=js"
export * from "./TabLeadInformation.vue?vue&type=script&lang=js"
import style0 from "./TabLeadInformation.vue?vue&type=style&index=0&id=67cd5504&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports